import React from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Box, useMediaQuery, useTheme, Typography
} from '@mui/material';

/**
 * Component Bảng dữ liệu dùng chung
 * - Desktop: Hiển thị dạng Bảng có thanh cuộn (Sticky Header)
 * - Mobile: Hiển thị dạng Thẻ (Card)
 */
const DataTable = ({ 
    columns, 
    data, 
    renderRow, 
    renderMobileCard, 
    maxHeight = '65vh', // Chiều cao mặc định (khoảng 10-12 dòng)
    noDataText = "Không có dữ liệu",
    summaryData = null
}) => {
    const theme = useTheme();

    // --- GIAO DIỆN DESKTOP (DẠNG BẢNG) ---
    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', borderRadius: 2, border: '1px solid #eee' }}>
            <TableContainer sx={{ maxHeight: maxHeight }}>
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            {columns.map((col, index) => (
                                <TableCell 
                                    key={index} 
                                    align={col.align || 'left'}
                                    style={{ 
                                        minWidth: col.minWidth, 
                                        fontWeight: 'bold', 
                                        backgroundColor: '#f5f5f5', // Màu nền header cố định
                                        color: '#2c3e50',
                                        zIndex: 10, // Đảm bảo đè lên nội dung khi cuộn
                                        height: '40px',
                                    }}
                                >
                                    {col.label}
                                </TableCell>
                            ))}
                        </TableRow>
                        {summaryData && (
                            <TableRow sx={{ backgroundColor: '#e0f2f1' }}>
                                {columns.map((col, index) => {
                                    const key = col.id || col.field;
                                    const value = key && summaryData[key] ? summaryData[key] : '';
                                    return (
                                        <TableCell 
                                            key={`sum-${index}`} 
                                            align={col.align || 'left'}
                                            sx={{ 
                                                fontWeight: 'bold', 
                                                color: '#007373', 
                                                borderBottom: '2px solid #007373',
                                                position: 'sticky',
                                                top: 39,
                                                zIndex: 10
                                            }}
                                        >
                                            {value}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        )}
                    </TableHead>
                    <TableBody>
                        {data.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
                                    <Typography color="text.secondary">{noDataText}</Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            data.map((row, index) => renderRow(row, index))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default DataTable;